module.exports = __webpack_public_path__ + "img/tap-menu-design2-min.ceeae283.jpg";